import React, { useEffect, useState } from "react";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../firebaseConfig";
import "./EditorialPanel.css";

const EditorialPanel = () => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedMember, setSelectedMember] = useState(null);
  useEffect(() => {
    loadMembers();
  }, []);

  const loadMembers = async () => {
    try {
      const q = query(
        collection(db, "editorial_panel"),
        orderBy("order", "asc")
      );

      const snap = await getDocs(q);

      const data = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setMembers(data);
    } catch (err) {
      console.error("Editorial Panel:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="editorial-loading">
        লোড হচ্ছে...
      </div>
    );
  }

  const editor =
    members.find((m) =>
      m.designation?.trim().includes("সম্পাদক")
    ) || null;

  const publisher =
    members.find((m) =>
      m.designation?.trim().includes("প্রকাশক")
    ) || null;

  const advisor =
    members.find((m) =>
      m.designation?.trim().includes("উপদেষ্টা")
    ) || null;

  const others = members.filter(
    (m) =>
      m.id !== editor?.id &&
      m.id !== publisher?.id &&
      m.id !== advisor?.id
  );
   
   return (
   <div className="editorial-page">

  <div className="editorial-header">
    <h1>সম্পাদক ও প্রকাশক প্যানেল</h1>
    <div className="editorial-line"></div>
  </div>

  <div className="top-members">

    {editor && (
      <div className="editor-card large-card"
	    onClick={() => setSelectedMember(editor)}
	  >
        <img src={editor.photo} alt={editor.name} />

        <div className="editor-card-body">
          <h2>{editor.name}</h2>
          <h4>{editor.designation}</h4>
        </div>
      </div>
    )}

    {publisher && (
      <div className="editor-card large-card"
	   onClick={() => setSelectedMember(publisher)}
	  >
	  
        <img src={publisher.photo} alt={publisher.name} />

        <div className="editor-card-body">
          <h2>{publisher.name}</h2>
          <h4>{publisher.designation}</h4>
        </div>
      </div>
    )}

  </div>

  {advisor && (
    <div className="advisor-wrapper">
      <div className="editor-card advisor-card"
	   onClick={() => setSelectedMember(advisor)}
	  >
        <img src={advisor.photo} alt={advisor.name} />

        <div className="editor-card-body">
          <h2>{advisor.name}</h2>
          <h4>{advisor.designation}</h4>
        </div>
      </div>
    </div>
  )}

  {others.length > 0 && (
    <>
      <div className="editorial-section-title">
        অন্যান্য সদস্য
      </div>

      <div className="members-grid">
        {others.map((member) => (
          <div key={member.id} className="editor-card member-card"
		    onClick={() => setSelectedMember(member)}
		  >

            <img
              src={member.photo}
              alt={member.name}
            />

            <div className="editor-card-body">
              <h2>{member.name}</h2>
              <h4>{member.designation}</h4>
            </div>

          </div>
        ))}
      
	  
	  {selectedMember && (
  <div
    className="editor-modal"
    onClick={() => setSelectedMember(null)}
  >
    <div
      className="editor-modal-content"
      onClick={(e) => e.stopPropagation()}
    >
      <button
        className="editor-close"
        onClick={() => setSelectedMember(null)}
      >
        ✕
      </button>

      <img
        src={selectedMember.photo}
        alt={selectedMember.name}
      />

      <h2>{selectedMember.name}</h2>

      <h4>{selectedMember.designation}</h4>

      <p>{selectedMember.bio}</p>

      {selectedMember.email && (
        <p>
          <strong>ই-মেইল:</strong> {selectedMember.email}
        </p>
      )}

      {selectedMember.phone && (
        <p>
          <strong>মোবাইল:</strong> {selectedMember.phone}
        </p>
      )}
    </div>
  </div>
)}
	  
	  </div>
    </>
  )}

</div>
  );
};
export default EditorialPanel;